"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var headerHelper_1 = require("./headerHelper");
//tslint:disable-next-line:no-unnecessary-class
var ResponseHelper = /** @class */ (function () {
    function ResponseHelper() {
    }
    ResponseHelper.getResponse = function (responseBody, responseHeaders) {
        if (responseBody && responseBody.length && headerHelper_1.HeaderHelper.isJson(responseHeaders)) {
            return JSON.parse(responseBody);
        }
        return responseBody;
    };
    return ResponseHelper;
}());
exports.ResponseHelper = ResponseHelper;
//# sourceMappingURL=responseHelper.js.map